/**
 *
 * Input Fields
 *
 */

import styled from 'styled-components';

import { COLORS } from 'utils/constants';

const Input = styled.input`
    width: 100%;
    height: 2.25rem;
    line-height: 2.125rem;
    margin: 0;
    padding: 0 .5rem;
    border: .0625rem solid ${COLORS.siteLightBlue};
    border-radius: .25rem;
    font-size: 1rem;
    
    &:active,
    &:focus {
        border-color: ${COLORS.siteBlue};
    }
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js